import { styled } from '@mui/material/styles';
import { Typography } from 'shared/mui/Typography';

export const TypographyStyled = styled(Typography)(({ underline }: { underline: boolean }) => ({
  textDecoration: underline ? 'underline' : 'none',
  textWrap: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}));
